import { render, staticRenderFns } from "./ThePageHeader.vue?vue&type=template&id=2a6252bd"
import script from "./ThePageHeader.vue?vue&type=script&lang=js"
export * from "./ThePageHeader.vue?vue&type=script&lang=js"
import style0 from "./ThePageHeader.vue?vue&type=style&index=0&id=2a6252bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports